import styled from 'styled-components';

const Title = styled.p`
  margin-bottom: 1.25rem;
  font-size: var(--font-size-m);
  color: var(--color-primary);
`;

export default Title;
